export default __webpack_public_path__ + "static/media/img5.42770688.png";